// Func = limiting Scope for this file
var lastScrollTop = 0;

(function(){

	const all_btns = document.querySelectorAll('.btn__solid');
	for (let i = 0; i < all_btns.length; i++) {
		let extra_btn_copy = all_btns[i].textContent;
		all_btns[i].innerHTML = extra_btn_copy+'<span class="mask-copy">'+extra_btn_copy+'</span>';   
	}
	//mobile burger menu
	document.getElementsByClassName('js-burger-menu')[0].addEventListener('click', function(){
		if(!this.classList.contains('open')){
			this.parentElement.classList.add('open');
			this.classList.add('open');
			document.getElementById('mobile-nav').classList.add('open');
	
		} else {
			this.classList.remove('open');
			this.parentElement.classList.remove('open');
			document.getElementById('mobile-nav').classList.remove('open');
		
		}
	});

	if(document.querySelector(".opentable__headline")) {
		let targetElement = document.querySelector(".top-content-home");
		let openTableTitle = document.querySelector(".opentable__headline");
		let openTableContent = document.querySelector(".opentable__widget-holder");
		
		// console.log( { targetElement, openTableTitle, openTableContent} );
		targetElement.insertAdjacentElement('afterbegin', openTableContent);
		openTableContent.insertAdjacentElement('beforebegin', openTableTitle)
	
	}
}());




	// body.appendChild(openTable)
	// console.log(body)
	// console.log(openTable)

// Simulate a click
function simulateClicHref(href) {
    if((document.querySelectorAll('a')) && (href == "restaurnt-menus__each2900")){
        let buttons = document.querySelectorAll('a');
        href="#restaurnt-menus__each2900";
        buttons.forEach(function(button) {
            if (button.getAttribute('href') === href) {
                button.click();
            }
        });
    }
}


function ScrollToSection(IdSection, margin){
	if (document.getElementById(IdSection)){
		let seccion = document.getElementById(IdSection);
		let posicion = seccion.getBoundingClientRect().top + window.scrollY - margin;
		window.scrollTo({ top: posicion, behavior: 'smooth' });
	}
	else{
		console.log("Id doesn't exist")
	}
}

function ConvertAnchorToId(anchor){
	let IdSection = anchor.substring(1).toLowerCase();
	if(IdSection == "sunday-brunch"){
		IdSection = "restaurnt-menus__each2900",
		simulateClicHref(IdSection)
		ScrollToSection(IdSection , 300);
	}
}

document.addEventListener('DOMContentLoaded', function () {
	let fragment = window.location.hash;
	if (fragment) {
		ConvertAnchorToId(fragment);
	}
});